import { Handshake, Building2, Users } from 'lucide-react';

const PartnershipsSection = () => {
  return (
    <section id="partnerships" className="py-24 lg:py-32 bg-[#f8f7f5]">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl serif font-light text-gray-900 mb-6">
            Partnerships
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We collaborate with businesses and organizations to provide exceptional wellness services through our referral program.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 mb-16">
          <div className="text-center space-y-4 p-8 bg-gradient-to-br from-purple-50/60 to-white rounded-lg border border-gray-200 hover:shadow-lg transition-all duration-300">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full">
              <Handshake className="text-purple-600" size={32} />
            </div>
            <h3 className="text-2xl serif font-medium text-gray-800">
              Referral Program
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Join our network of trusted partners and provide your clients with transformative wellness services.
            </p>
          </div>

          <div className="text-center space-y-4 p-8 bg-gradient-to-br from-green-50/60 to-white rounded-lg border border-gray-200 hover:shadow-lg transition-all duration-300">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full">
              <Building2 className="text-green-600" size={32} />
            </div>
            <h3 className="text-2xl serif font-medium text-gray-800">
              Corporate Wellness
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Enhance employee wellbeing through customized yoga and somatic therapy programs.
            </p>
          </div>

          <div className="text-center space-y-4 p-8 bg-gradient-to-br from-gray-50 to-white rounded-lg border border-gray-200 hover:shadow-lg transition-all duration-300">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full">
              <Users className="text-gray-600" size={32} />
            </div>
            <h3 className="text-2xl serif font-medium text-gray-800">
              Community Partners
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Build meaningful connections through collaborative wellness initiatives and events.
            </p>
          </div>
        </div>

        <div className="text-center bg-white/80 backdrop-blur-sm border border-gray-200 rounded-lg p-8 lg:p-12 shadow-lg">
          <h3 className="text-2xl serif font-medium text-gray-800 mb-4">
            Interested in Partnering?
          </h3>
          <p className="text-gray-600 leading-relaxed mb-8">
            We're always looking to connect with like-minded businesses and organizations who share our commitment to holistic wellness and transformation. Reach out to explore partnership opportunities.
          </p>
          <a
            href="mailto:info@heisewellness.com?subject=Partnership Inquiry"
            className="inline-block bg-gray-800 hover:bg-gray-900 text-white px-12 py-4 rounded-md transition-all duration-300 hover:shadow-lg font-medium"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default PartnershipsSection;